(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gameday-sale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gameday-sale')) {
    customElements.define('gameday-sale', class extends HTMLElement {
      connectedCallback() {
        const end = Date.parse(this.dataset.endsAt);
        const time = this.querySelector('time');
        if (!Number.isFinite(end)) { this.remove(); return; }
        const update = () => {
          const remaining = end - Date.now();
          if (remaining <= 0) { this.remove(); return; }
          const minutes = Math.ceil(remaining / 60000);
          time.textContent = `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m left`;
          time.title = `Ends ${new Date(end).toLocaleString()}`;
        };
        update();
        if (this.isConnected) this.timer = setInterval(update, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["native-school-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (new URLSearchParams(location.search).get('satco_native_school') === 'off') return;
    const formSelector = 'form[data-testid="klaviyo-form-UyPrYs"]';
    const mobile = window.matchMedia('(max-width: 767px), (pointer: coarse)');
    const instances = new Map();
    const attempted = new WeakSet();
    const inputValueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    const styleProperties = [
      'background-color', 'border-top', 'border-right', 'border-bottom', 'border-left',
      'border-radius', 'font-family', 'font-weight', 'font-style', 'letter-spacing',
      'line-height', 'text-align', 'color', 'padding-top', 'padding-bottom', 'padding-left',
    ];

    function waitFor(root, predicate) {
      return new Promise((resolve, reject) => {
        let observer;
        let timeout;
        const check = () => {
          const result = root.isConnected && predicate();
          if (!result) return;
          observer?.disconnect();
          clearTimeout(timeout);
          resolve(result);
        };
        observer = new MutationObserver(check);
        observer.observe(root, { childList: true, subtree: true, attributes: true });
        timeout = setTimeout(() => {
          observer.disconnect();
          reject(new Error('Klaviyo school control did not respond'));
        }, 1000);
        check();
      });
    }

    function enhance(input, form) {
      const label = document.getElementById(input.getAttribute('aria-labelledby'));
      const menu = document.getElementById(input.getAttribute('aria-controls'));
      const control = input.parentElement;
      const toggle = control.querySelector('button');
      if (label?.textContent.trim() !== 'School' || !menu || !form.contains(menu) || !toggle) return;
      attempted.add(input);

      const original = new Map(['readonly', 'tabindex', 'aria-hidden'].map(name => [name, input.getAttribute(name)]));
      const originalToggleHidden = toggle.getAttribute('aria-hidden');
      const select = document.createElement('select');
      select.className = 'saturday-school-select needsclick';
      select.id = `${input.id}-native`;
      select.setAttribute('aria-labelledby', label.id);
      select.setAttribute('aria-required', input.getAttribute('aria-required') || 'false');
      select.disabled = true;
      const placeholder = new Option(input.placeholder, '');
      placeholder.disabled = true;
      select.add(placeholder);
      let active = true;
      let pending = true;
      let chosenLabel = input.value;
      let labels = [];
      let changing = false;
      let revision = 0;
      const appearance = getComputedStyle(input);
      const placeholderColor = getComputedStyle(input, '::placeholder').color;
      const textColor = appearance.color;
      for (const property of styleProperties) select.style.setProperty(property, appearance.getPropertyValue(property));
      select.style.fontSize = `${Math.max(16, parseFloat(appearance.fontSize) || 16)}px`;
      select.style.paddingRight = '40px';
      select.style.paddingLeft = `${(parseFloat(appearance.paddingLeft) || 0) + (parseFloat(getComputedStyle(control).paddingLeft) || 0)}px`;

      const sync = () => {
        if (!active) return;
        for (const name of ['aria-invalid', 'aria-describedby', 'aria-errormessage']) {
          const value = input.getAttribute(name);
          if (value === null) select.removeAttribute(name);
          else if (select.getAttribute(name) !== value) select.setAttribute(name, value);
        }
        select.style.color = select.value ? textColor : placeholderColor;
        select.style.borderColor = getComputedStyle(input).borderColor;
      };

      const closeMenu = () => {
        if (input.isConnected && input.getAttribute('aria-expanded') === 'true') toggle.click();
      };

      const restore = () => {
        if (!active) return;
        active = false;
        stateObserver.disconnect();
        form.removeEventListener('click', guard, true);
        form.removeEventListener('submit', guard, true);
        input.removeEventListener('focus', redirectFocus);
        closeMenu();
        select.remove();
        control.removeAttribute('data-saturday-school-control');
        menu.removeAttribute('data-saturday-school-menu');
        for (const [name, value] of original) {
          if (value === null) input.removeAttribute(name);
          else input.setAttribute(name, value);
        }
        if (originalToggleHidden === null) toggle.removeAttribute('aria-hidden');
        else toggle.setAttribute('aria-hidden', originalToggleHidden);
        instances.delete(input);
      };

      const redirectFocus = () => {
        if (active && !select.disabled) select.focus({ preventScroll: true });
      };

      const guard = event => {
        const button = event.target.closest('button');
        const continues = event.type === 'submit' || (button && button !== toggle && button.hasAttribute('data-action-id'));
        if (!continues) return;
        const diverged = select.value !== '' && input.value !== labels[Number(select.value)];
        if (pending || diverged) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!pending && diverged) restore();
        }
      };

      const stateObserver = new MutationObserver(sync);
      stateObserver.observe(input, { attributes: true });
      instances.set(input, restore);
      form.addEventListener('click', guard, true);
      form.addEventListener('submit', guard, true);
      input.addEventListener('focus', redirectFocus);
      input.readOnly = true;
      input.tabIndex = -1;
      input.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-hidden', 'true');
      control.setAttribute('data-saturday-school-control', '');
      menu.setAttribute('data-saturday-school-menu', '');
      control.append(select);

      const openOptions = async () => {
        if (!active) throw new Error('School control was removed');
        if (input.value) {
          inputValueSetter.call(input, '');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          await new Promise(requestAnimationFrame);
        }
        if (!active) throw new Error('School control was removed');
        if (input.getAttribute('aria-expanded') !== 'true') toggle.click();
        await new Promise(requestAnimationFrame);
        return waitFor(menu, () => {
          const options = Array.from(menu.querySelectorAll('[role="option"]'));
          return options.length && options;
        });
      };

      const commit = async labelText => {
        const options = await openOptions();
        if (!active) return;
        const matches = options.filter(option => option.textContent.trim() === labelText);
        if (matches.length !== 1 || matches[0].getAttribute('aria-disabled') === 'true') throw new Error('School option changed');
        matches[0].click();
        await waitFor(control, () => input.value === labelText && input.getAttribute('aria-expanded') === 'false');
      };

      const change = async () => {
        revision += 1;
        if (changing) return;
        changing = true;
        pending = true;
        try {
          let committedRevision;
          do {
            committedRevision = revision;
            chosenLabel = labels[Number(select.value)];
            if (!chosenLabel) throw new Error('Unknown school choice');
            await commit(chosenLabel);
          } while (active && committedRevision !== revision);
          pending = false;
          sync();
        } catch (error) {
          console.warn('[Saturday] Restored Klaviyo school control:', error.message);
          restore();
        } finally {
          changing = false;
        }
      };

      select.addEventListener('change', change);
      (async () => {
        try {
          const options = await openOptions();
          if (!active) return;
          labels = options.map(option => option.textContent.trim());
          if (labels.some(labelText => !labelText) || new Set(labels).size !== labels.length) throw new Error('Ambiguous schools');
          labels.forEach((labelText, index) => select.add(new Option(labelText, String(index))));
          if (chosenLabel) {
            if (!labels.includes(chosenLabel)) throw new Error('Previous school missing');
            await commit(chosenLabel);
            select.value = String(labels.indexOf(chosenLabel));
          } else {
            closeMenu();
            select.value = '';
          }
          pending = false;
          select.disabled = false;
          sync();
        } catch (error) {
          console.warn('[Saturday] Kept Klaviyo school control:', error.message);
          restore();
        }
      })();
    }

    function scan() {
      for (const [input, restore] of instances) {
        if (!input.isConnected || !mobile.matches) {
          restore();
          attempted.delete(input);
        }
      }
      if (!mobile.matches) return;
      document.querySelectorAll(formSelector).forEach(form => {
        form.querySelectorAll('.klaviyo-dropdown input[role="combobox"]').forEach(input => {
          if (!attempted.has(input)) enhance(input, form);
        });
      });
    }

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        scan();
      });
    };
    const discovery = new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
    });
    discovery.observe(document.body, { childList: true, subtree: true });
    mobile.addEventListener('change', schedule);
    window.addEventListener('klaviyoForms', schedule);
    scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
